/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "styled-components";
import { formatterUS } from "../helpers/moneyFormat";
import { Grid, Typography, Card, CardContent } from "@material-ui/core";

//Icons
import ticket from "../icons/menu/ticket_average.svg";
import total from "../icons/menu/total_icon.svg";
import mount from "../icons/menu/total_mount.svg";
import average from "../icons/menu/order_average.svg";

const StyledCard = styled(Card)`
  background: rgba(230, 159, 25, 0.08);
  border-radius: 8px;

  .number {
    color: #e69f1a;
    font-size: 21px;
    font-weight: bold;
  }

  .title {
    color: #e69f1a;
    font-size: 10px;
    font-weight: bold;
  }
`;

const CardMetric = ({ values, listRecords }: any) => {
  const totalValue = listRecords.length;
  let montoTotal = 0;
  let sumorderLines = 0;
  listRecords.forEach((val: any) => {
    montoTotal += val.formattedDataBean.grandTotal;
    sumorderLines += val.numberItems;
  });

  let pOrderLineValue = Math.round(sumorderLines / totalValue) || 0;

  let ticketPromedioValue = montoTotal / totalValue || 0;

  const titles = [
    {
      image: total,
      title: "TOTAL",
      value: totalValue,
    },
    {
      image: mount,
      title: "MONTO TOTAL",
      isMoney: true,
      value: montoTotal,
    },
    {
      image: average,
      title: "PROMEDIO ORDER LINES",
      value: pOrderLineValue,
    },
    {
      image: ticket,
      title: "TICKET PROMEDIO",
      isMoney: true,
      value: ticketPromedioValue,
    },
  ];

  return (
    <>
      {titles.map((e: any, index: number) => (
        <Grid item xs={6} md={3} key={index}>
          <StyledCard>
            <CardContent>
              <Grid container direction="row" alignItems="center">
                <Grid item xs={3}>
                  <img src={e.image} alt="icon" />
                </Grid>
                <Grid item xs={9}>
                  {e.isMoney ? (
                    <Typography className="number">
                      {formatterUS.format(e.value)}
                    </Typography>
                  ) : (
                    <Typography className="number">{e.value}</Typography>
                  )}
                  <Typography color="textPrimary" className="title">
                    {e.title}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </StyledCard>
        </Grid>
      ))}
    </>
  );
};

export default CardMetric;
